import CompanyReportsDetails from './CompanyReportsDetails';

export default CompanyReportsDetails;
